import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import PaymentPanel from './PaymentPanel';
import ButtonDefault from '../../../components/ButtonDefault/ButtonDefault';
import TimelyStatic from '../StaticPage/TimelyStatic';

import { MarketData } from '../../../MockData/MarketData';
import Number from '../../../components/Number/Number';
import MailerSendStatic from '../StaticPage/MailerSendStatic';
import TDBFileStatic from '../StaticPage/TDBFileStatic';
import { UserContext } from '../../../context/UserContext';
import { TooltipHost } from '@fluentui/react';
import { API } from '../../../API/API';
import { DataGrid } from 'devextreme-react';
import { Column, Lookup } from 'devextreme-react/data-grid';
import WorkiStatic from '../StaticPage/WorkiStatic';
import DiwoAIStatic from '../StaticPage/DiwoAIStatic';


const MarketDtl = () => {

    const params = useParams();
    const { userInfo } = useContext(UserContext);

    const [data, setData] = useState({});
    const [featureEndDate, setFeatureEndDate] = useState();
    const [featureLog, setfeatureLog] = useState([]);
    const [featureStatus] = useState([{ key: 0, text: 'НЭХЭМЖЛЭХ ИЛГЭЭСЭН' }, { key: 1, text: 'ТӨЛСӨН' }, { key: 2, text: 'ЦУЦАЛСАН' }]);
    const [showPayment, setShowPayment] = useState(false);

    const getData = async () => {
        let tData = {};

        if (params?.id) {
            let tIndex = MarketData?.map(r => r.id?.toString()).indexOf(params?.id?.toString());
            if (tIndex >= 0) {
                tData = MarketData[tIndex];
            }

            await API.get(`/api/shared/user-management/feature/list/${userInfo?.companyid}?featureid=${params?.id}&onlyActive=false`).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    setfeatureLog(response.data.retdata);
                    if (response.data.retdata?.length > 0) {
                        let max = Math.max(...response.data.retdata.map(feature => feature.enddate ? new Date(feature.enddate) : null));
                        if (max > 0)
                            setFeatureEndDate(new Date(max).toISOString().split('T')[0]);
                    }
                }
            });
        }

        setData(tData);
    }

    useEffect(() => {
        getData();
    }, [params?.id]);

    const onActivate = () => {
        setShowPayment(true);
    }

    const onDismiss = () => {
        setShowPayment(false);
        getData();
    }

    let vBody = null;
    if (params?.id == 2) {
        vBody = <TimelyStatic />;
    } else if (params?.id == 4) {
        vBody = <MailerSendStatic />;
    } else if (params?.id == 5) {
        vBody = <TDBFileStatic />;
    } else if (params?.id == 6) {
        vBody = <WorkiStatic />;
    } else if (params?.id == 7) {
        vBody = <DiwoAIStatic />;
    }

    return (
        <div style={{ width: '80%', backgroundColor: '#FFFFFF', padding: 16 }}>
            <div style={{ display: 'flex' }}>
                <div style={{ fontSize: 20, fontWeight: 600, color: '#212121', flex: 1 }}>
                    {data?.title} <p style={{ fontSize: 12, fontWeight: 400, marginTop: 4, color: '#555555' }}>Оруулсан: {data?.company}</p>
                </div>
                <TooltipHost content={userInfo?.features?.includes(data.code) ? `${data.title} идэвхтэй байна. Дуусах огноо: ${featureEndDate ? featureEndDate : 'хугацаагүй'}` : ''}>
                    <ButtonDefault onClick={onActivate} text="Идэвхжүүлэх" disabled={userInfo?.features?.includes(data.code)} />
                </TooltipHost>
            </div>
            {vBody}
            <div style={{ width: '100%', display: 'flex', borderBottom: '2px solid #DFDFDF' }}>
                <div style={{ fontSize: 16, fontWeight: 600, color: '#212121', paddingBottom: 8, borderBottom: '2px solid #0358A7', marginBottom: -2 }}>Төлбөр</div>
            </div>
            <div style={{ display: 'flex', marginTop: 12, alignItems: 'center' }}>
                <div style={{ fontSize: 24, fontWeight: 600, color: '#000000', marginRight: 6 }}>
                    <Number symbol textAlign='left' value={data?.price} />
                </div>
                <div style={{ fontSize: 12, fontWeight: 400, color: '#959595', marginTop: 2 }}>{data?.hidepricetype ? null : " / Сарын төлбөр"}</div>
            </div>
            {featureLog?.length > 0 && (
                <>
                    <div style={{ width: '100%', marginTop: 12, display: 'flex', borderBottom: '2px solid #DFDFDF' }}>
                        <div style={{ fontSize: 16, fontWeight: 600, color: '#212121', paddingBottom: 8, borderBottom: '2px solid #0358A7', marginBottom: -2 }}>Түүх</div>
                    </div>
                    <div style={{ display: 'flex', marginTop: 12, alignItems: 'center' }}>
                        <DataGrid
                            dataSource={featureLog}
                            showBorders={true}
                            hoverStateEnabled={true}
                            wordWrapEnabled={false}>
                            <Column dataField="invoicedate" caption="Нэхэмжлэхийн огноо" dataType="date" format="yyyy-MM-dd" />
                            <Column dataField="begdate" caption="Эхлэх огноо" dataType="date" format="yyyy-MM-dd" sortOrder="desc" />
                            <Column dataField="enddate" caption="Дуусах огноо" dataType="date" format="yyyy-MM-dd" calculateCellValue={(r) => { return r.enddate?.substring(0, 10) ?? '-' }} />
                            <Column dataField="status" caption="Төлөв" calculateCellValue={(r) => { return r.status === 0 && new Date(r.duedate) < Date.now() ? 2 : r.status }}  >
                                <Lookup dataSource={featureStatus} valueExpr="key" displayExpr="text" />
                            </Column>

                        </DataGrid>
                    </div>
                </>
            )}
            {showPayment ? <PaymentPanel id={params?.id} title='Төлбөр төлөх' isOpen={showPayment} onDismiss={onDismiss} /> : null}
        </div>
    );
}

export default MarketDtl;